import React, { useEffect } from 'react'
import Navbar from './Navbar';
import "../assets/moncompte.css"
import { Link } from 'react-router-dom';

function MonCompte() {

  useEffect(()=>{
    
    let header = document.querySelector('#menu');
    let burger = document.querySelector('.navbar-toggler');
    header?.classList.add('bg-navbar');

    if (window.screen.width < 985) {
      header?.classList.remove('scrolled');
      header?.classList.remove('bg-navbar');
      header?.classList.add('menuPanierOuProduit');
      burger?.classList.add("menuburger");
    }
  }, [])
  return (
    <div>
        <Navbar />
        <div id="monCompte" className='container mt-5 text-center col-md-4 col-sm-6'>
          <h1>MON COMPTE</h1>
          <form action="">
            <div className="form-group">
              <input type="email" placeholder='Adresse mail' className='form-control' />
            </div>
            <div className="form-group mb-2">
              <input type="password" placeholder='Mot de passe' className='form-control mt-3' />
            </div>
            <Link className='text-center text-success'>Mot de passe oublié</Link>
            <button type='submit' className='btn btn-dark form-control mt-5' id='btn-validate'>Je me connecte </button>
            <Link to={window.location.origin+"/creation-compte"} className='btn btn-outline-success mt-2 form-control' id='btn-validate'>Je me crée un compte </Link>
          </form>
        </div>
    </div>
  )
}

export default MonCompte